export var VaiBorder;
(function (VaiBorder) {
    VaiBorder["SizeXl"] = "0.375rem";
    VaiBorder["SizeL"] = "0.25rem";
    VaiBorder["SizeM"] = "0.125rem";
    VaiBorder["SizeS"] = "0.0625rem";
    VaiBorder["RadiusCircle"] = "50%";
    VaiBorder["RadiusS"] = "0.0625rem";
})(VaiBorder || (VaiBorder = {}));
export var VaiBreakpoint;
(function (VaiBreakpoint) {
    VaiBreakpoint["S"] = "576px";
    VaiBreakpoint["M"] = "768px";
    VaiBreakpoint["L"] = "992px";
    VaiBreakpoint["Xl"] = "1200px";
})(VaiBreakpoint || (VaiBreakpoint = {}));
export var VaiColor;
(function (VaiColor) {
    VaiColor["White"] = "#ffffff";
    VaiColor["Grey"] = "#b5b5b5";
    VaiColor["GreyLight"] = "#f5f5f5";
    VaiColor["GreyLight2"] = "#e8e8e8";
    VaiColor["GreyLight3"] = "#cfcfcf";
    VaiColor["GreyMedium"] = "#696969";
    VaiColor["GreyMedium2"] = "#4f4f4f";
    VaiColor["GreyDark"] = "#363636";
    VaiColor["ColdGrey"] = "#e4e8ed";
    VaiColor["BlueLight"] = "#e6f5fa";
    VaiColor["BlueLight2"] = "#ccebf4";
    VaiColor["BlueDark"] = "#003462";
    VaiColor["AquaVaisala"] = "#009ac8";
    VaiColor["AquaMedium"] = "#1ab4e2";
    VaiColor["AquaDark"] = "#0081af";
    VaiColor["AquaDark2"] = "#006795";
    VaiColor["MintGreen"] = "#33b28e";
    VaiColor["MintGreenDark"] = "#007f5b";
    VaiColor["LeafGreen"] = "#00bf64";
    VaiColor["LeafGreenMedium"] = "#007318";
    VaiColor["LeafGreenDark"] = "#004000";
    VaiColor["Yellow"] = "#ffe34d";
    VaiColor["YellowLight"] = "#ffffb3";
    VaiColor["Orange"] = "#ffb01a";
    VaiColor["OrangeDark"] = "#ff9600";
    VaiColor["Red"] = "#df1616";
    VaiColor["Pink"] = "#ffb0b2";
    VaiColor["BackgroundGrey"] = "#f5f6f8";
    VaiColor["BackgroundGreyDark"] = "#161616";
    VaiColor["Black"] = "#000000";
    VaiColor["BlackLight"] = "#080b0d";
    VaiColor["GreyDark2"] = "#1c1c1c";
    VaiColor["Graphite"] = "#1d2426";
    VaiColor["GraphiteDark"] = "#101719";
    VaiColor["GraphiteLight"] = "#434a4c";
    VaiColor["GraphiteLight2"] = "#373e40";
    VaiColor["GraphiteLight3"] = "#2a3133";
    VaiColor["AccentAqua"] = "#28525c";
    VaiColor["AccentAquaDark"] = "#0f3943";
    VaiColor["AccentAquaLight"] = "#5b858f";
    VaiColor["AccentAquaLight2"] = "#426c76";
    VaiColor["TextPrimary"] = "#003462";
    VaiColor["TextSecondary"] = "#696969";
    VaiColor["TextInteractive"] = "#009ac8";
    VaiColor["TextError"] = "#df1616";
    VaiColor["TextDisabled"] = "#b5b5b5";
    VaiColor["TextPrimaryDark"] = "#b5b5b5";
    VaiColor["TextSecondaryDark"] = "#696969";
    VaiColor["TextInteractiveDark"] = "#28525c";
    VaiColor["TextErrorDark"] = "rgba(223, 22, 22, 0.75)";
    VaiColor["TextDisabledDark"] = "#4f4f4f";
    VaiColor["WashedYellow"] = "rgba(255,227,77, 0.75)";
    VaiColor["WashedYellowLight"] = "rgba(255,255,179, 0.75)";
    VaiColor["WashedOrange"] = "rgba(255,176,26, 0.75)";
    VaiColor["WashedOrangeDark"] = "rgba(255,150,0, 0.75)";
    VaiColor["WashedPink"] = "rgba(255,176,178, 0.75)";
    VaiColor["WashedRed"] = "rgba(223,22,22, 0.75)";
    VaiColor["WashedAquaMedium"] = "rgba(26,180,226, 0.75)";
    VaiColor["WashedAccentAqua"] = "rgba(40,82,92, 0.75)";
    VaiColor["WashedMintGreen"] = "rgba(51,178,142, 0.75)";
    VaiColor["WashedMintGreenDark"] = "rgba(0,127,91, 0.75)";
    VaiColor["WashedLeafGreen"] = "rgba(0,191,100, 0.75)";
    VaiColor["WashedLeafGreenMedium"] = "rgba(0,115,24, 0.75)";
    VaiColor["WashedLeafGreenDark"] = "rgba(0,64,0, 0.75)";
    VaiColor["AlertOk"] = "#33b28e";
    VaiColor["AlertInfo"] = "#009ac8";
    VaiColor["AlertWarning"] = "#ff9600";
    VaiColor["AlertAlarm"] = "#df1616";
    VaiColor["AlertError"] = "#df1616";
    VaiColor["AlertOkDark"] = "#28886e";
    VaiColor["AlertInfoDark"] = "#027699";
    VaiColor["AlertWarningDark"] = "#c17303";
    VaiColor["AlertAlarmDark"] = "#a91314";
    VaiColor["AlertErrorDark"] = "#a91314";
    VaiColor["ChartPrimary1"] = "#229ce2";
    VaiColor["ChartPrimary2"] = "#a84900";
    VaiColor["ChartPrimary3"] = "#9e9410";
    VaiColor["ChartPrimary4"] = "#b40a32";
    VaiColor["ChartPrimary5"] = "#01a277";
    VaiColor["ChartPrimary6"] = "#006ba8";
    VaiColor["ChartPrimary7"] = "#c67bac";
    VaiColor["ChartSecondary1"] = "#000000";
    VaiColor["ChartSecondary2"] = "#006e82";
    VaiColor["ChartSecondary3"] = "#8214a0";
    VaiColor["ChartSecondary4"] = "#005ac8";
    VaiColor["ChartSecondary5"] = "#00a0fa";
    VaiColor["ChartSecondary6"] = "#fa78fa";
    VaiColor["ChartSecondary7"] = "#14d2dc";
    VaiColor["ChartSecondary8"] = "#aa0a3c";
    VaiColor["ChartSecondary9"] = "#0a9b4b";
    VaiColor["ChartSecondary10"] = "#ff825f";
    VaiColor["ChartSecondary11"] = "#ead644";
    VaiColor["ChartSecondary12"] = "#a0fa82";
    VaiColor["ChartSecondary13"] = "#fae6be";
})(VaiColor || (VaiColor = {}));
export var VaiFont;
(function (VaiFont) {
    VaiFont["SizeBase"] = "16px";
    VaiFont["SizeP"] = "1rem";
    VaiFont["SizeXl"] = "1.3125rem";
    VaiFont["SizeL"] = "1.125rem";
    VaiFont["SizeM"] = "1rem";
    VaiFont["SizeS"] = "0.875rem";
    VaiFont["SizeXs"] = "0.82rem";
    VaiFont["SizeXxs"] = "0.625rem";
})(VaiFont || (VaiFont = {}));
export var VaiIconSize;
(function (VaiIconSize) {
    VaiIconSize["Xl"] = "1.875rem";
    VaiIconSize["L"] = "1.5rem";
    VaiIconSize["M"] = "1.25rem";
    VaiIconSize["S"] = "1.125rem";
    VaiIconSize["Xs"] = "1rem";
})(VaiIconSize || (VaiIconSize = {}));
export var VaiOpacity;
(function (VaiOpacity) {
    VaiOpacity["Level15"] = "0.15";
    VaiOpacity["Level25"] = "0.25";
    VaiOpacity["Level50"] = "0.5";
    VaiOpacity["Level75"] = "0.75";
    VaiOpacity["Level85"] = "0.85";
})(VaiOpacity || (VaiOpacity = {}));
export var VaiShadow;
(function (VaiShadow) {
    VaiShadow["LevelNone"] = "0px 0px 0px 0px";
    VaiShadow["Level1"] = "0px 1px 2px 0px";
    VaiShadow["Level2"] = "0px 1px 4px 0px";
    VaiShadow["Level3"] = "2px 0px 8px 0px";
    VaiShadow["Level4"] = "0px 6px 12px 0px";
    VaiShadow["Focus"] = "0px 0px 5px 0px";
})(VaiShadow || (VaiShadow = {}));
export var VaiSpacing;
(function (VaiSpacing) {
    VaiSpacing["Base"] = "0.5rem";
    VaiSpacing["Xxl"] = "2.5rem";
    VaiSpacing["Xl"] = "2rem";
    VaiSpacing["L"] = "1.5rem";
    VaiSpacing["M"] = "1rem";
    VaiSpacing["S"] = "0.5rem";
    VaiSpacing["Xs"] = "0.25rem";
    VaiSpacing["Xxs"] = "0.125rem";
})(VaiSpacing || (VaiSpacing = {}));
export var VaiZIndex;
(function (VaiZIndex) {
    VaiZIndex["ZIndexDefault"] = "1";
    VaiZIndex["ZIndexSidepanel"] = "300";
    VaiZIndex["ZIndexHeader"] = "400";
    VaiZIndex["ZIndexDropdown"] = "500";
    VaiZIndex["ZIndexTooltip"] = "600";
    VaiZIndex["ZIndexNavigation"] = "700";
    VaiZIndex["ZIndexOverlay"] = "800";
    VaiZIndex["ZIndexDrawer"] = "900";
    VaiZIndex["ZIndexModal"] = "1000";
    VaiZIndex["ZIndexSpinner"] = "1100";
    VaiZIndex["ZIndexToaster"] = "1200";
    VaiZIndex["ZIndexDeep"] = "-99999";
})(VaiZIndex || (VaiZIndex = {}));
